// USERS
export const ACTION_SIGNUP_CREATE = "user/ACTION_SIGNUP_CREATE";
export const ACTION_SIGNUP_UPDATE = "user/ACTION_SIGNUP_UPDATE";
// PROFIL
export const ACTION_PROFILE_INIT = "profile/ACTION_PROFILE_INIT";
export const ACTION_ADMIN_FOLDER_INIT = "profile/ACTION_ADMIN_FOLDER_INIT";
export const ACTION_ACCOUNT_INIT = "profile/ACTION_ACCOUNT_INIT";
export const ACTION_PROFILE_GET_SUBSCRIPTION_STATUS = "profile/ACTION_PROFILE_GET_SUBSCRIPTION_STATUS";
// DASHBOARD
export const ACTION_DASHBOARD_OPEN_RECRUITMENT_RECAP_MODAL = "dashboard/ACTION_DASHBOARD_OPEN_RECRUITMENT_RECAP_MODAL";
export const ACTION_DASHBOARD_CLOSE_RECRUITMENT_RECAP_MODAL = "dashboard/ACTION_DASHBOARD_CLOSE_RECRUITMENT_RECAP_MODAL";
export const ACTION_DASHBOARD_SET_DRAWER_TITLE = "dashboard/ACTION_DASHBOARD_SET_DRAWER_TITLE";
// FAMILY
export const ACTION_FAMILY_INIT = "family/ACTION_FAMILY_INIT";
// CREATION DEMAND
export const ACTION_CREATION_TEMPLATE_PUBLISH = "creation_demand/ACTION_CREATION_TEMPLATE_PUBLISH";
export const ACTION_CREATION_TEMPLATE_PUBLISH_AE = "creation_demand/ACTION_CREATION_TEMPLATE_PUBLISH_AE";
// QUALIFICATIONS
export const ACTION_QUALIFICATIONS_GET_ALL = "qualifications/ACTION_QUALIFICATION_GET_ALL";
// EXTRA
export const ACTION_EXTRA_GET_BY_ID = "extra/ACTION_EXTRA_GET_BY_ID";
export const ACTION_EXTRA_GET_SKILLS_BY_ID = "extra/ACTION_EXTRA_GET_SKILLS_BY_ID";
export const ACTION_EXTRA_GET_BIO_BY_ID = "extra/ACTION_EXTRA_GET_BIO_BY_ID";
export const ACTION_EXTRA_GET_LANGUAGE_BY_ID = "extra/ACTION_EXTRA_GET_LANGUAGE_BY_ID";
export const ACTION_EXTRA_GET_SKILLS = "extra/ACTION_EXTRA_GET_SKILLS";
export const ACTION_EXTRA_GET_LANGUAGES = "extra/ACTION_EXTRA_GET_LANGUAGES";
export const ACTION_EXTRA_GET_COURSES = "extra/ACTION_EXTRA_GET_COURSES";
export const ACTION_EXTRA_GET_EXPERIENCES = "extra/ACTION_EXTRA_GET_EXPERIENCES";
// RECRUITMENT CANDIDATES
export const ACTION_RECRUITMENT_CANDIDATES_GET_DEMAND_CONTACTED = "recruitment_candidates/ACTION_RECRUITMENT_CANDIDATES_GET_DEMAND_CONTACTED";
export const ACTION_RECRUITMENT_CANDIDATES_GET_APPLIED = "recruitment_candidates/ACTION_RECRUITMENT_CANDIDATES_GET_APPLIED";
export const ACTION_RECRUITMENT_CANDIDATES_GET_CONTACTED = "recruitment_candidates/ACTION_RECRUITMENT_CANDIDATES_GET_CONTACTED";
export const ACTION_RECRUITMENT_CANDIDATES_GET_RECRUITED = "recruitment_candidates/ACTION_RECRUITMENT_CANDIDATES_GET_RECRUITED";
export const ACTION_RECRUITMENT_CANDIDATES_GET_IGNORED = "recruitment_candidates/ACTION_RECRUITMENT_CANDIDATES_GET_IGNORED";
export const ACTION_RECRUITMENT_CANDIDATES_GET_REPORT_REASONS = "recruitment_candidates/ACTION_RECRUITMENT_CANDIDATES_GET_REPORT_REASONS";
export const ACTION_RECRUITMENT_CANDIDATES_FILTERS_GET_LANGUAGE_OPTIONS =
  "recruitment_candidates/ACTION_RECRUITMENT_CANDIDATES_FILTERS_GET_LOCATION_OPTIONS";
export const ACTION_RECRUITMENT_CANDIDATES_FILTERS_GET_LOCATION_OPTIONS =
  "recruitment_candidates/ACTION_RECRUITMENT_CANDIDATES_FILTERS_GET_LANGUAGE_OPTIONS";
export const ACTION_RECRUITMENT_CANDIDATES_FILTERS_GET_EXPERIENCE_OPTIONS =
  "recruitment_candidates/ACTION_RECRUITMENT_CANDIDATES_FILTERS_GET_EXPERIENCE_OPTIONS";
export const ACTION_RECRUITMENT_CANDIDATES_SET_ACTUAL_LOADING_NUMBER =
  "recruitment_candidates/ACTION_RECRUITMENT_CANDIDATES_SET_ACTUAL_LOADING_NUMBER";
// RECRUITMENTS
export const ACTION_RECRUITMENTS_GET_IN_PROGRESS = "recruitments/ACTION_RECRUITMENTS_GET_IN_PROGRESS";
export const ACTION_RECRUITMENTS_GET_UPCOMING = "recruitments/ACTION_RECRUITMENTS_GET_UPCOMING";
export const ACTION_RECRUITMENTS_SET_SELECTED = "recruitments/ACTION_RECRUITMENTS_SET_SELECTED";
export const ACTION_RECRUITMENTS_SET_SELECTED_EXTRA = "recruitments/ACTION_RECRUITMENTS_SET_SELECTED_EXTRA";
export const ACTION_RECRUITMENTS_SOFT_REMOVE = "recruitments/ACTION_RECRUITMENTS_SOFT_REMOVE";
// RECRUITMENT
export const ACTION_RECRUITMENT_GET_BY_ID = "recruitment/ACTION_RECRUITMENT_GET_BY_ID";
export const ACTION_RECRUITMENT_GET = "recruitment/ACTION_RECRUITMENT_GET";
export const ACTION_RECRUITMENT_RESET = "recruitment/ACTION_RECRUITMENT_RESET";
// SUBSCRIPTION
export const ACTION_SUBSCRIPTION_GET_SUBSCRIPTION_OFFERS = "subscription/ACTION_SUBSCRIPTION_GET_SUBSCRIPTION_OFFERS";
export const ACTION_SUBSCRIPTION_SELECT_OFFER = "subscription/ACTION_SUBSCRIPTION_SELECT_OFFER";
export const ACTION_SUBSCRIPTION_GET_PAYMENT_SESSION = "subscription/ACTION_SUBSCRIPTION_GET_PAYMENT_SESSION";
export const ACTION_SUBSCRIPTION_GET_PAYMENT_LINK = "subscription/ACTION_SUBSCRIPTION_GET_PAYMENT_LINK";
export const ACTION_SUBSCRIPTION_HAS_SUBSCRIPTION = "subscription/ACTION_SUBSCRIPTION_HAS_SUBSCRIPTION";
// ACTIVATION
export const ACTION_ACTIVATION_GET_DEMAND_RECAP = "activation/ACTION_ACTIVATION_GET_DEMAND_RECAP";
// SUBSCRIBED
export const ACTION_SUBSCRIBED_GET_INFORMATIONS = "subscribed/ACTION_SUBSCRIBED_GET_INFORMATIONS";
// SURVEY
export const ACTION_SURVEY_GET_AMOUNT = "survey/ACTION_SURVEY_GET_AMOUNT";
export const ACTION_SURVEY_GET_EXTRA_SCHEDULES = "survey/ACTION_SURVEY_GET_EXTRA_SCHEDULES";
export const ACTION_SURVEY_GET_EXTRA_REVIEWS = "survey/ACTION_SURVEY_GET_EXTRA_REVIEWS";
// STORE
export const ACTION_RESET_STORE = "store/ACTION_RESET_STORE";
// SESSION
export const ACTION_SESSION_HIDE_FILTERS = "session/ACTION_SESSION_HIDE_FILTERS";
export const ACTION_SESSION_SHOW_FILTERS = "session/ACTION_SESSION_SHOW_FILTERS";
// REPORT MODAL
export const ACTION_REPORT_DEMAND_SET = "report_modal/ACTION_REPORT_DEMAND_SET";
export const ACTION_REPORT_MODAL_SET = "report_modal/ACTION_REPORT_MODAL_SET";
export const ACTION_REPORT_CANDIDATE_SET = "report_modal/ACTION_REPORT_CANDIDATE_SET";
